export { StarHalf as default } from './StarHalf';
